export default __webpack_public_path__ + "static/media/login-bg.98ee076f.svg";